module.exports = __webpack_public_path__ + "media/BNP_Samodzielniak_6_A_24.cd8bc9ac.mp3";